import styled from 'styled-components';
import { Flex } from 'UI';

export const Scale = styled(Flex)<{ value: number; origin?: 'left' | 'right' | 'top' | 'bottom' }>`
  transform: scale(${({ value }) => value});
  transform-origin: ${({ origin }) => (origin ? origin : 'center')};
`;
